import React from 'react';
import "./Text.css";

const Text = () => {
  return (
    <div className="text-wrapper">
        <div className="tw-header">
            <div className='Star'>
                <img src="https://res.cloudinary.com/dspelvbl1/image/upload/f_auto,q_auto/v1773091837/Star_1_vvtjst.png" alt="Star" className="Star-img"/>
            </div>
            <div className='twh-text'>Available For Opportunities</div>
        </div>
        <div className="tw-body-head">I’m Remzy, <br/> a UI/UX, Web & Graphics Designer.</div>
        <div className="twb-body">At RemzyArts, I craft modern websites and visual identities that blend creativity with strategy. Sleek, responsive, and designed to convert. <br/> Whether it’s UI/UX design, web development, or brand graphics, I’m here to give you the best.</div>
        
      <div className="hero-actions">
        <a href="https://wa.link/q7egxz">
        <button className="lt">Let's Talk</button>
        </a>
        <a href="https://drive.google.com/drive/folders/1Odbc_PQ3PjWPNmTIQNRkF7doesPTTCZH?usp=drive_link">
        <button className='mw'>My Works</button>
        </a>
      </div>    
    </div>
  )
  }

  export default Text;